import React, { PureComponent } from 'react'
import { omit } from 'lodash'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { withStyles } from 'material-ui-next/styles'
import { truncate } from 'lodash'
import Chip from 'material-ui-next/Chip'
import {
  getDistrictFilter,
  getTotalItems,
  getItemsLoading,
} from '../../selectors'
import {
  parseQsGenere,
  mergeQs,
  makeParseQsAttributesValuesMem,
  parseQsAttributes,
} from '../../utils'
import MediaQuery from 'react-responsive'
import breakpoints from '../../styles/breakpoints'
import { fade } from 'material-ui-next/styles/colorManipulator'
import { CircularProgress } from 'material-ui-next/Progress'

const styles = theme => ({
  chip: {
    margin: 3,
    fontSize: 13,
    color: theme.swapick.colors.energized,
    [`@media (max-width: ${breakpoints.md})`]: {
      fontSize: 10,
    },
  },
  secondary: {
    color: theme.swapick.colors.secondary,
    '&:hover': {
      color: fade(theme.swapick.colors.secondary, 0.7),
    },
  },
  row: {
    marginRight: 3,
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  circularProg: {
    position: 'relative',
    top: 2,
  },
})

class FilterChip extends PureComponent {
  clearGenereFilter = () => {
    this.props.history.push(
      `${this.props.location.pathname}?${mergeQs(this.props.location, {
        genere: '',
      })}`
    )
  }

  clearDistrictFilter = () => {
    this.props.history.push(
      `${this.props.location.pathname}?${mergeQs(this.props.location, {
        district: '',
      })}`
    )
  }

  clearAttributeFilter = attributo => {
    const currentAttributes = parseQsAttributes(this.props.location)
    const attributi = omit(currentAttributes, attributo)
    this.props.history.push(
      `${this.props.location.pathname}?${mergeQs(this.props.location, {
        attributi: JSON.stringify(attributi),
      })}`
    )
  }

  clearAllFilter = () => {
    this.props.history.push(
      `${this.props.location.pathname}?${mergeQs(this.props.location, {
        district: '',
        genere: '',
        attributi: '',
      })}`
    )
  }

  render() {
    const {
      classes,
      genereFilter,
      districtFilter,
      attributesFilter,
      totalItems,
      isItemLoading,
    } = this.props

    return (
      <MediaQuery minWidth={breakpoints.sm}>
        <div className={classes.row}>
          {genereFilter && (
            <Chip
              onDelete={this.clearGenereFilter}
              label={genereFilter}
              className={classes.chip}
            />
          )}
          {districtFilter && (
            <Chip
              onDelete={this.clearDistrictFilter}
              label={districtFilter}
              className={classes.chip}
            />
          )}
          {attributesFilter.map(attr => (
            <Chip
              key={attr.chiave}
              onDelete={() => this.clearAttributeFilter(attr.chiave)}
              label={truncate(attr.valore, { length: 15 })}
              className={classes.chip}
            />
          ))}
          {(genereFilter || districtFilter || attributesFilter.length > 0) && (
            <Chip
              onDelete={this.clearAllFilter}
              label={
                <span>
                  {isItemLoading ? (
                    <CircularProgress
                      color="accent"
                      size={15}
                      classes={{ root: classes.circularProg }}
                    />
                  ) : (
                    totalItems
                  )}{' '}
                  Risultati
                </span>
              }
              className={classes.chip}
              classes={{
                label: classes.secondary,
                deleteIcon: classes.secondary,
              }}
            />
          )}
        </div>
      </MediaQuery>
    )
  }
}

const parseQsAttributesValuesMem = makeParseQsAttributesValuesMem()

const mapStateToProps = (state, ownProps) => {
  return {
    genereFilter: parseQsGenere(ownProps.location),
    districtFilter: getDistrictFilter(state, ownProps.location, 'automobile'),
    attributesFilter: parseQsAttributesValuesMem(ownProps.location),
    isItemLoading: getItemsLoading(state),
    totalItems: getTotalItems(state),
  }
}

export default withStyles(styles)(
  withRouter(connect(mapStateToProps)(FilterChip))
)



// WEBPACK FOOTER //
// ./src/common/TopBar/FilterChip.js